import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { loginUser } from "../utils/fetchFunctions";
import Button from "../components/Button";
import InputField from "../components/InputField";
import FormError from "../components/FormError";
import FormContainer from "../components/FormContainer";
import "./auth.css";

/**
 * @description Login page component that handles user authentication and redirects based on user role.
 * @returns {JSX.Element} Login form with email and password fields
 */
const Login = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);

    try {
      const data = await loginUser(email, password);

      if (data.user && data.user.role === "admin") {
        navigate("/admin/dashboard");
      } else {
        navigate("/dashboard");
      }
    } catch (err) {
      if (err.message && err.message.includes("verifizieren")) {
        setError(err.message + " Please check your email inbox.");
      } else {
        setError(err.message || "Login failed");
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <main className="auth-page">
      <FormContainer>
        <header>
          <h1 className="auth-title">Log In</h1>
          <p className="auth-subtitle">Welcome back!</p>
        </header>

        <form className="auth-form" onSubmit={handleSubmit}>
          <InputField
            id="email"
            type="email"
            label="Email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />

          <InputField
            id="password"
            type="password"
            label="Password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
          />

          <div className="forgot-password-link-container">
            <Link
              to="/forgot-password"
              className="forgot-password-link"
            >
              Forgot password?
            </Link>
          </div>

          <FormError message={error} />

          <Button
            type="submit"
            className="auth-button"
            disabled={loading}
            loading={loading}
            loadingText="Please wait…"
          >
            Log in
          </Button>
        </form>

        <footer className="auth-footer">
          Don't have an account? <Link to="/register">Sign up now</Link>
        </footer>
      </FormContainer>
    </main>
  );
};

export default Login;
